export const VAT_RATES = [
  { value: 0, label: "0% (momsfri)" },
  { value: 6, label: "6% (motion/idrott)" },
  { value: 12, label: "12% (mat/dryck)" },
  { value: 25, label: "25% (standard)" },
] as const;

export const DEFAULT_VAT_BY_TYPE: Record<string, number> = {
  court_booking: 6,
  membership: 6,
  league: 6,
  tournament: 6,
  training: 6,
  addon: 25,
  credit_package: 6,
  product: 25,
  food: 12,
};

/**
 * Calculate VAT amount from a price that includes VAT.
 * Swedish VAT is always included in the price (bruttopris).
 */
export function vatFromGross(grossPrice: number, vatPercent: number): number {
  return Math.round((grossPrice * vatPercent) / (100 + vatPercent) * 100) / 100;
}

/**
 * Calculate net price (excl. VAT) from gross price (incl. VAT).
 */
export function netFromGross(grossPrice: number, vatPercent: number): number {
  return Math.round((grossPrice * 100) / (100 + vatPercent) * 100) / 100;
}
